<template>
  <div class="global-content-box global-content-flex">
    <div class="displayItem" style="margin-bottom: 24px">
      <y-menu-title title="行为等级规则" class="title" />
      <!-- 启用状态 -->
      <div class="displayItem">
        <y-button type="blueLine" @click="toPage('swicth')">
          <img
            src="@/assets/images/memberAll/change.svg"
            alt
            style="
              width: 16px;
              height: 16px;
              margin-right: 8px;
              vertical-align: middle;
            "
          />切换等级规则方案
        </y-button>
      </div>
    </div>
    <div class="global-felx">
      <!-- 提示语 -->
      <y-tip>
        <div class="tipsCont">
          1.所有与订单有关的指标，都是按订单的 “下单时间” 进行统计。
        </div>
        <div class="tipsCont">
          2.当会员退会后，若设置了对应的退会清零指标，则对这部分的会员需做降级处理。
        </div>
        <div class="tipsCont">
          3.所有与订单有关的指标，都是按订单的 “下单时间” 进行统计。
        </div>
        <div class="tipsCont">
          4.若开启了升级条件，则每个级别至少设置一个有效的升级规则。
        </div>
      </y-tip>
      <!-- 设置表单 -->
      <el-form :model="form" ref="form" label-width="160px">
        <el-form-item label="启用等级升级规则：" style="margin-top: 20px">
          <el-switch v-model="isStart" @change="isChangeSwitch"> </el-switch>
        </el-form-item>
        <el-form-item label="等级有效期：">
          <el-radio v-model="radio" label="1">永久有效</el-radio>
        </el-form-item>
        <el-form-item label="数据有效范围：">
          <span style="margin-right: 8px">从</span>
          <el-date-picker
            v-model="form.orderValidDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          ></el-date-picker>
          <span style="margin-left: 8px">开始累计订单</span>
        </el-form-item>
        <el-form-item label="升级规则：">
          <el-radio-group
            v-model="form.behaviorLevelCalcRule"
            @change="changeBehaviorLevelCalcRule"
          >
            <el-radio :label="0">交易金额</el-radio>
            <el-radio :label="2"
              >交易金额和交易次数（满足其中一个要求即可升级等级）</el-radio
            >
          </el-radio-group>
        </el-form-item>
        <el-form-item label="等级设置：">
          <!-- 表格 -->
          <y-table
            :tableInfo="tableInfo"
            :tableData="form.gradeDetailList"
            :autoMaxHeight="false"
          >
            <template #gradeRule="scope">
              <div v-if="scope.rowIndex == 0" class="displayItem tableCont">
                最低等级，无需设置升级规则
              </div>
              <div
                class="displayItem"
                style="justify-content: flex-start"
                v-else
              >
                <div class="tableCont">
                  <div class="displayItem">
                    订单指标：累计交易金额（实付）满:
                    <el-input
                      v-model="scope.row.upgradeMinMoney"
                      v-numHave2Decimal
                      class="inline_input"
                      placeholder="请输入"
                      @blur="handleMoney"
                    ></el-input>
                    元
                  </div>
                  <div>且</div>
                  <div class="displayItem" style="margin-left: -16px">
                    <el-tooltip class="item" effect="dark" placement="top">
                      <div slot="content">
                        包含特定商品：特定商品的订单才会纳入计算范围。<br />
                        排除特定商品：除特定商品外，其他商品的订单均纳入计算范围。若订单内含排除商品，则该笔订单排除不算入。
                      </div>
                      <img
                        src="@/assets/new-image/header/quest.svg"
                        alt
                        style="width: 14px; height: 14px; margin-right: 4px"
                      />
                    </el-tooltip>
                    商品指标：
                    <el-radio-group v-model="scope.row.itemSelectType">
                      <el-radio :label="0">不限</el-radio>
                      <el-radio :label="1">
                        <span>
                          包含特定商品
                          <span v-if="scope.row.itemSelectType == 1">
                            <span
                              class="select_btn"
                              @click="selectGoods(1, scope.rowIndex)"
                              >已选择
                              <span style="color: #ff8d59">{{
                                scope.row.specificItems.length
                              }}</span>
                              个商品</span
                            >
                          </span>
                        </span>
                      </el-radio>
                      <el-radio :label="2">
                        <span>
                          排除特定商品
                          <span v-if="scope.row.itemSelectType == 2">
                            <span
                              class="select_btn"
                              @click="selectGoods(2, scope.rowIndex)"
                              >已选择
                              <span style="color: #ff8d59">{{
                                scope.row.excludeItems.length
                              }}</span>
                              个商品</span
                            >
                          </span>
                        </span>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </div>
              </div>
            </template>
            <template #trade="scope">
              <div v-if="scope.rowIndex == 0" class="displayItem tableCont">
                最低等级，无需设置升级规则
              </div>
              <div
                class="displayItem"
                style="justify-content: flex-start"
                v-else
              >
                <div class="tableCont">
                  <div class="displayItem">
                    订单指标：累计交易次数满:
                    <el-input
                      v-model="scope.row.upgradeMinCount"
                      v-numZOnly
                      class="inline_input"
                      placeholder="请输入"
                    ></el-input>
                    次
                  </div>
                </div>
              </div>
            </template>
          </y-table>
        </el-form-item>
      </el-form>
    </div>
    <!-- 保存 -->
    <div class="global-bottom-btn">
      <y-button type="blue" v-if="loading" :loading="loading">保存</y-button>
      <y-button type="blue" v-else :loading="loading" @click="save">
        保存
      </y-button>
    </div>
    <!-- 选择商品组件 -->
    <select-goods
      v-if="goodsState"
      @transferName="goodsPopupBtn"
      :postForm="goodsPostForm"
      :skuIsShow="false"
      :scoresCardId="$store.state.MemberSystemInfo.scoresCardId"
    ></select-goods>
  </div>
</template>

<script>
import { upRuleSwitch, getDetail, ruleSave } from "@/api/manage/scoreList";
import { getDetailById } from "@/api/integralCenter/newMemberSystem";
import selectGoods from "@/components/select-goods.vue";
export default {
  components: {
    selectGoods,
  },
  props: {
    upRuleType: {
      default: "",
    },
  },
  data() {
    return {
      isStart: false, //是否启用规则
      _upRuleType: "",
      form: {
        orderValidDate: "",
        behaviorLevelCalcRule: 0,
        gradeDetailList: [],
      },
      radio: "1",
      gradeList: [
        // 会员等级设置
        { gradeCode: 1, gradeName: "店铺客户" },
      ],
      loading: false,
      goodsState: false, // 选择商品弹窗
      goodsPostForm: [], // 已选商品数据---弹窗用
      selectGoodsList: [], // 已选商品列表--指定商品
      selectGoodsList2: [], // 已选商品列表--排除特定商品
      selectGoodsType: 1, // 用于储存当前打开的弹窗类型，因公用一个组件，以此区分
      selectGoodsIndex: 1, // 用于储存当前选择商品的下标

      tableInfo: [
        {
          label: "等级名称",
          prop: "gradeName",
          width: "400px",
        },
        {
          label: "升级规则",
          prop: "gradeName",
          slot: "gradeRule",
        },
      ],
    };
  },
  created() {
    // 获取当前会员体系详情
    this.MemberSystemInfo = this.$store.state.MemberSystemInfo;
    console.log("this.MemberSystemInfo", this.MemberSystemInfo);
  },
  mounted() {
    this.getDetail();
    //判断开启状态
    console.log("this.upRuleType", this.upRuleType);
    this._upRuleType = this.upRuleType;
    if (this._upRuleType == 1) {
      this.isStart = true;
    }
  },
  methods: {
    //查询会员卡行为等级规则详情
    getDetail() {
      getDetail({ cardId: this.MemberSystemInfo.scoresCardId }).then((res) => {
        this.form = res.data;
        this.form.gradeDetailList.forEach((item, index) => {
          console.log("item", item);
          item.specificItems = [];
          item.excludeItems = [];
          if (
            item.itemSelectType == 1 &&
            item.gradeItems &&
            item.gradeItems.length > 0
          ) {
            item.gradeItems.forEach((goods, index) => {
              let newItem = {
                itemTitle: goods.itemName,
                price: goods.itemPrice,
                picUrl: goods.itemImage,
                numIid: goods.itemSkuId,
                channelSellerManageId: goods.channelSellerManageId,
                platform: goods.platform,
              };
              item.specificItems.push(newItem);
              console.log("newItem", item.specificItems);
            });
          } else if (
            item.itemSelectType == 2 &&
            item.gradeItems &&
            item.gradeItems.length > 0
          ) {
            item.gradeItems.forEach((goods, index) => {
              let newItem = {
                itemTitle: goods.itemName,
                price: goods.itemPrice,
                picUrl: goods.itemImage,
                numIid: goods.itemSkuId,
                channelSellerManageId: goods.channelSellerManageId,
                platform: goods.platform,
              };
              item.excludeItems.push(newItem);
            });
          } else {
            item.specificItems = [];
            item.excludeItems = [];
          }
        });
        console.log("this.form", this.form);
        this.changeBehaviorLevelCalcRule(res.data.behaviorLevelCalcRule);
      });
    },
    // 保存
    save() {
      if (!this.form.orderValidDate) {
        this.$message.warning("请选择数据有效范围!");
        return;
      }
      let isOk = false;
      console.log(
        "this.form.gradeDetailList",
        this.form.gradeDetailList.length
      );
      this.form.gradeDetailList.forEach((item, index) => {
        if (!isOk && !item.upgradeMinMoney && index != 0) {
          this.$message.warning("请填写" + item.gradeName + "累计交易金额!");
          isOk = true;
          return;
        }
        if (this.form.behaviorLevelCalcRule == 2) {
          if (!isOk && !item.upgradeMinCount && index != 0) {
            this.$message.warning("请填写" + item.gradeName + "累计交易次数!");
            isOk = true;
            return;
          }
        }
      });
      if (!isOk && this.form.gradeDetailList.length > 2) {
        for (let i = 1; i < this.form.gradeDetailList.length - 1; i++) {
          console.log("i", i);
          if (
            !isOk &&
            Number(this.form.gradeDetailList[i + 1].upgradeMinMoney) <=
              Number(this.form.gradeDetailList[1].upgradeMinMoney)
          ) {
            this.$message.warning(
              this.form.gradeDetailList[i].gradeName +
                "级别的累计交易金额不可大于或者等于" +
                this.form.gradeDetailList[i + 1].gradeName +
                "级别"
            );
            isOk = true;
            return;
          }
          if (this.form.behaviorLevelCalcRule == 2) {
            if (
              !isOk &&
              Number(this.form.gradeDetailList[i + 1].upgradeMinCount) <=
                Number(this.form.gradeDetailList[1].upgradeMinCount)
            ) {
              this.$message.warning(
                this.form.gradeDetailList[i].gradeName +
                  "级别的累计交易次数不可大于或者等于" +
                  this.form.gradeDetailList[i + 1].gradeName +
                  "级别"
              );
              isOk = true;
              return;
            }
          }
        }
      }
      if (isOk) {
        return;
      }
      //根据接口进行处理
      this.form.scoresCardId = this.MemberSystemInfo.scoresCardId;
      let _from = JSON.parse(JSON.stringify(this.form));
      _from.gradeDetailList = _from.gradeDetailList.slice(1);
      _from.gradeDetailList.forEach((item, index) => {
        // console.log("item",item)
        item.gradeItems = [];
        if (item.itemSelectType == 1 && item.specificItems.length > 0) {
          item.specificItems.forEach((goods, index) => {
            let newItem = {
              itemName: goods.itemTitle,
              itemPrice: goods.price,
              itemImage: goods.picUrl,
              itemSkuId: goods.numIid,
              channelSellerManageId: goods.channelSellerManageId,
              platform: goods.platform,
            };
            item.gradeItems.push(newItem);
          });
        } else if (item.itemSelectType == 2 && item.excludeItems.length > 0) {
          item.excludeItems.forEach((goods, index) => {
            let newItem = {
              itemName: goods.itemTitle,
              itemPrice: goods.price,
              itemImage: goods.picUrl,
              itemSkuId: goods.numIid,
              channelSellerManageId: goods.channelSellerManageId,
              platform: goods.platform,
            };
            item.gradeItems.push(newItem);
          });
        }
        delete item.specificItems;
        delete item.excludeItems;
      });
      console.log("this.form", _from);
      ruleSave(_from).then((res) => {
        if (res.code == 200) {
          this.$message.success("保存成功");
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 切换模块
    toPage(name) {
      this.$emit("toPage", name);
    },
    //改变启用状态
    isChangeSwitch() {
      let newType = this.isStart;
      this.isStart = false;
      console.log(" this.upRuleType1", this._upRuleType);
      if (this._upRuleType == 2) {
        this.isStart = false;
        this.$message.warning("启用失败: 启用行为等级规则需关闭成长值等级规则");
      } else {
        let params = {
          cardId: this.$store.state.MemberSystemInfo.scoresCardId,
          upRuleType: 1,
          state: newType,
        };
        upRuleSwitch(params)
          .then((res) => {
            if (res.code == 200) {
              console.log("newType", newType);
              if (newType) {
                this.isStart = true;
                this._upRuleType = 1;
                this.$message.warning("启用成功");
              } else {
                this.isStart = false;
                this.$message.warning("修改成功");
                this._upRuleType = "";
              }
              this.$emit("changeUpRuleType", this._upRuleType);
            } else {
              this.isStart = false;
            }
          })
          .catch((err) => {
            this.isStart = false;
          });
      }
    },
    // 选择商品弹窗
    selectGoods(val, index) {
      // val：1指定商品 2排除特定商品
      // 记录当前打开的是哪种条件的弹窗
      this.selectGoodsType = val;
      this.selectGoodsIndex = index;
      console.log(
        "this.form.gradeDetailList",
        this.form.gradeDetailList[index]
      );
      // 修改弹窗回显
      if (val == 1) {
        this.goodsPostForm = this.form.gradeDetailList[index].specificItems;
        this.goodsState = true;
      } else {
        this.goodsPostForm = this.form.gradeDetailList[index].excludeItems;
        this.goodsState = true;
      }
    },
    goodsPopupBtn(event, state) {
      // state：0取消 1确定
      this.goodsState = false;
      console.log("选择完返回的数据event", event, state);
      if (state == 1) {
        if (this.selectGoodsType == 1) {
          this.form.gradeDetailList[this.selectGoodsIndex].specificItems =
            event;
        }
        if (this.selectGoodsType == 2) {
          this.form.gradeDetailList[this.selectGoodsIndex].excludeItems = event;
        }
        // this.form.gradeDetailList[this.selectGoodsIndex].gradeItems = event
        this.$nextTick(() => {
          this.form = JSON.parse(JSON.stringify(this.form));
          console.log("333-", this.form.gradeDetailList);
        });
      }
    },
    handleMoney(event) {
      if (Number(event.target.value) == Number(0)) {
        event.target.value = "0.01";
      }
    },
    changeBehaviorLevelCalcRule(val) {
      if (val == 0) {
        const index = this.tableInfo.findIndex((item) => item.prop == "trade");
        if (index != -1) {
          this.tableInfo.splice(index, 1);
        }
      } else if (val == 2) {
        this.tableInfo.push({
          label: "交易笔数",
          prop: "trade",
          slot: "trade",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-input__prefix {
  left: 3px !important;
}
.displayItem {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.title {
  margin-bottom: 0px;
  margin-right: 24px;
}
.tableCont {
  width: 100%;
  text-align: left;
  padding: 6px 0px 6px 20px;
  // margin: 0 5%;
  .select_btn {
    color: $theme-color;
    // margin: 0 10px;
    margin-left: 12px;
    cursor: pointer;

    span {
      margin: 0 5px;
    }
  }
}

.inline_input {
  width: 100px;
  margin: 0 8px;
}
</style>